import { useState, useRef, useEffect } from "react";
import { SearchInput } from "@/ui/inputs/Input";
import useTableService from "@/components/useTableServerSide";
import Footer from "@/components/Footer";
import axios from "axios";
import { Dimmer } from "@/components/spinner";
import { ActualizarEstadoCuenta } from "./modalActualizarEstadoCuenta";
import { Mensaje } from "@/components/mensajes2";
import comercioService from "./service/comercio.service";
export default function TablaEstadoCuenta(props) {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const espiritu = localStorage.getItem("espiritu");
  const factorCambio = JSON.parse(localStorage.getItem("factorCambio"));
  const fechaSistema = localStorage.getItem("fechasistema");
  const searchTimeoutRef = useRef(null);
  const [searchInput, setSearchInput] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [mostrarEstadoCuenta, setMostrarEstadoCuenta] = useState(false);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [comercio, setComercio] = useState();
  const [persona, setPersona] = useState();
  const [actividad, setActividad] = useState();
  const [inmuebleCome, setInmuebleCome] = useState();
  const [deuda, setDeuda] = useState([]);
  const [historico, setHistorico] = useState([]);
  const [multas, setMultas] = useState([]);
  const [retencion, setRetencion] = useState([]);
  const [facturasPagadas, setFacturasPagadas] = useState();
  const [facturasPagadasEtax, setFacturasPagadasEtax] = useState();
  const [facturasOtrosPgosEtax, setFacturasOtrosPgosEtax] = useState();
  const [statusCome, setStatusCome] = useState();
  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    search: "",
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const headCells = [
    {
      id: "idcomercio",
      label: "CODIGO",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
    },
    {
      id: "ritm",
      label: "RITM",
      width: "60px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
    },
    {
      id: "rif",
      label: "RIF",
      width: "60px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
    },
    {
      id: "nombre",
      label: "NOMBRE",
      width: "300px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
    },
    {
      id: "reprelegal",
      label: "CEDULA",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
    },
    {
      id: "accion",
      label: "OPCIONES",
      width: "120px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
    },
  ];

  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),
    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({ ...prev, rowsPerPage: newLimit, page: 0 })),
    onSortChange: (orderBy, orderDir) =>
      setTableState((prev) => ({ ...prev, orderBy, orderDir, page: 0 })),
  };

  const { TblContainer, TblHead, TblPagination } = useTableService(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (value.length === 0)
      return setTableState((prev) => ({ ...prev, search: "", page: 0 }));
    if (value.length < 3) return;
    searchTimeoutRef.current = setTimeout(
      () => setTableState((prev) => ({ ...prev, search: value, page: 0 })),
      500,
    );
  };

  const buscarRegistrosComercios = () => {
    setLoading(true);
    const campos = `idcomercio, nombre, rif, ritm, reprelegal`;
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
      campos: campos,
      nomtab: "comercio",
      orden: "idcomercio desc",
    };
    const endpoint = `${op.conexion}/api/comun/seleccionar-registros-paginacion`;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          setRecords(response.data.rows);
          setTotalRecords(response.data.count);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));
  };
  const buscarComercio = async (idComercio) => {
    setLoading(true);
    try {
      const resComercio = await axios.get(
        `${op.conexion}/api/industria/comerciopersona?idcomercio=${idComercio}`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      const dataCom = resComercio.data;
      setComercio(dataCom);

      const idactividad = dataCom?.idactividad || 0;
      const idinmueble = dataCom?.idinmueble || 0;
      const esagente = dataCom?.esagentereten || false;

      setPersona({
        cedula: dataCom.cedula,
        nombres: dataCom.nombres,
        apellidos: dataCom.apellidos,
        correoe: dataCom.correoe,
        tlf1: dataCom.tlf1,
        tlf2: dataCom.tlf2,
        fnacimiento: dataCom.fnacimiento,
        nacionalidad: dataCom.nacionalidad,
        sexo: dataCom.sexo,
        direccion: dataCom.direccionp,
      });

      const resActividad = await axios.get(
        `${op.conexion}/api/industria/actividad?idactividad=${idactividad}`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (resActividad.data.length > 0) setActividad(resActividad.data);

      const resInmueble = await axios.get(
        `${op.conexion}/api/industria/inmueblexcomercio?idinmueble=${idinmueble}`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (resInmueble.data) setInmuebleCome(resInmueble.data);
      const endpointDeuda =
        espiritu === '0'
          ? `${op.conexion}/api/industria/deudacomerciors?idcomercio=${idComercio}&fecha=${fechaSistema}&espiritu=${espiritu}&tipounid=1`
          : `${op.conexion}/api/industria/deudacomercio?idcomercio=${idComercio}&fecha=${fechaSistema}&espiritu=${espiritu}&tipounid=1`;

      const resDeuda = await axios.get(endpointDeuda, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });

      let deu = [];
      let his = [];
      if (resDeuda.data && resDeuda.data.length > 0) {
        for (let i = 0; i < resDeuda.data.length; i++) {
          const d = resDeuda.data[i];
          if (d.fechapago === null) {
            deu.push({
              anio: d.anio,
              mes: d.mes.replace("'", "").replace("'", ""),
              monto: d.mondeu,
              intereses: d.intmoradeu,
              recargo: d.recargodeu,
              multa: d.multa,
              retenciones: d.retencion,
              credito: d.acreditacion,
              totalperi: d.subtotal,
              status: d.estatus,
              idfac: d.idfact,
              nummes: d.nmes,
              estatusfac: d.estatusfac,
              tipotransaccion: d.tipotransaccion,
              tipodeuda: d.tipodeuda,
              nombredeuda: espiritu === 0 ? d.nombredeuda : "deudacomercio",
              idrent: espiritu === 0 ? d.idrent : 0,
            });
          } else {
            his.push({
              anio: d.anio,
              mes: d.mes.replace("'", "").replace("'", ""),
              monto: d.mondeu,
              intereses: d.intmoradeu,
              recargo: d.recargodeu,
              multa: d.multa,
              descuento: d.mondescue,
              recibo: d.numreci,
              fechapago: d.fechapago,
              status: d.estatus,
              idfac: d.idfact,
              estatusfac: d.estatusfac,
              tipotransaccion: d.tipotransaccion,
            });
          }
        }
      }
      setDeuda(deu);
      setHistorico(his);

     const campMultas =
        "idmulta, fechamulta, CONCAT(descripcion, ' (', tipoimpuesto, ')') AS descripcion, concepto, monto, cancelada";
      const endpointMultas = `${op.conexion}/api/comun/seleccionaregistros?campos=
      ${campMultas}&nomtab=multa 
      where idcontribuyente = ${idComercio} and (tipoimpuesto = 'RENTAS DE LICORES' or  tipoimpuesto = 'ACTIVIDADES ECONOMICAS')
      &orden=idmulta desc`;
      const resMultas = await axios.get(endpointMultas, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      setMultas(resMultas.data);

      if (esagente) {
        const resFacturas = await axios.get(
          `${op.conexion}/api/industria/facturaspagadas?idcomercio=${idComercio}`,
          {
            headers: {
              "x-access-token": `${token}`,
              "Content-Type": "application/json",
            },
          },
        );
        setFacturasPagadas(resFacturas.data);

        const resRetenciones = await axios.get(
          `${op.conexion}/api/industria/retencionesxagente?idcomercio=${idComercio}`,
          {
            headers: {
              "x-access-token": `${token}`,
              "Content-Type": "application/json",
            },
          },
        );
        setRetencion(resRetenciones.data);
      } else {
        setFacturasPagadas([]);
        setRetencion([]);
      }
      //Status
      const data = await comercioService.getStatus();
      var come = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].tipostatus.trim() === "COMERCIO") {
          come.push({
            idstatus: data[i].idstatus,
            descripcion: data[i].descripcion,
          });
        }
        setStatusCome(come);
      }
      setMostrarEstadoCuenta(true);
    } catch (error) {
      console.error("Error en el flujo de peticiones:", error);
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto:
          error.response?.data?.message ||
          "Error al cargar la información del comercio",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const cerrarModal = () => {
    setMostrarEstadoCuenta(false);
    setComercio();
    setPersona();
    setActividad();
    setInmuebleCome();
    setDeuda([]);
    setHistorico([]);
    setMultas([]);
    setRetencion([]);
    setFacturasPagadas();
    setFacturasPagadasEtax();
    setFacturasOtrosPgosEtax();
  };
  const cerrar = () => {
    props.setTabla(0);
  };

  useEffect(() => {
    const cleanup = buscarRegistrosComercios();
    return () => {
      if (cleanup) cleanup();
    };
  }, [tableState]);
  return (
    <div>
      <div className="col-8 m-0 my-5 p-2 border rounded mx-auto">
        <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top azulGradiant text-light">
          <h3 className="fw-bold text-light m-0">
            Consultar Estados de Cuentas Actividad Ecomica
          </h3>
          <button onClick={() => cerrar()} className="btn btn-sm bg-light">
            <i className="fa fa-times"></i>
          </button>
        </header>
        <div className="col-4 m-0 my-2 p-0">
          <SearchInput
            className="search-input pe-4"
            value={searchInput}
            onChange={handleSearch}
          />
        </div>
        <section className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                records.map((item, index) => (
                  <tr key={index} style={{ padding: "0" }}>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: "10px" }}
                    >
                      {item.idcomercio}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: "80px" }}
                    >
                      {item.ritm}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: "80px" }}
                    >
                      {item.rif}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "left", width: "500px" }}
                    >
                      {item.nombre}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: "80px" }}
                    >
                      {item.reprelegal}
                    </td>
                    <td
                      align="center"
                      className="align-baseline"
                      style={{ textAlign: "center", width: "100px" }}
                    >
                      <button
                        className="btn btn-sm btn-info rounded-pill"
                        onClick={() => buscarComercio(item.idcomercio)}
                      >
                        <i className="fas fa-search" />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </section>
      </div>
      <ActualizarEstadoCuenta
        show={mostrarEstadoCuenta}
        onHideCancela={cerrarModal}
        actividad={actividad}
        comercio={comercio}
        statuscome={statusCome}
        actividadcome={actividad}
        representante={persona}
        tabdeuda={deuda}
        tabpago={historico}
        tabmulta={multas}
        tabreten={retencion}
        inmueble={inmuebleCome}
        espiritu={espiritu}
        factpago={facturasPagadas}
        factorCambio={factorCambio?.valor}
        factpagoetax={facturasPagadasEtax}
        factotropagoetax={facturasOtrosPgosEtax}
        deshabilitado={true}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={loading} inverted />
      <Footer />
    </div>
  );
}
